// extracted by mini-css-extract-plugin
export var button = "BackToTopBtn-module--button--6668d";
export var cdsAssistiveText = "BackToTopBtn-module--cds--assistive-text--19344";
export var cdsHideFeedback = "BackToTopBtn-module--cds--hide-feedback--a3c9f";
export var cdsShowFeedback = "BackToTopBtn-module--cds--show-feedback--7406a";
export var cdsSkeleton = "BackToTopBtn-module--cds--skeleton--07680";
export var cdsVisuallyHidden = "BackToTopBtn-module--cds--visually-hidden--f7a6a";